
export enum LiquidityLadder {
    Exclude = 0,
    Include = 1,
    CapitalOnly = 2,
}